export enum CreditHoldReason {
    AccountOnWatch = 0,
    CertifiedFunds = 1,
    CIA = 2,
    Collections = 3,
    DemandLetter = 4,
    HoldingCheck = 5,
    NSFCheck = 6,
    OverCreditLimit = 7,
    OverCreditLimitAndPastDue = 8,
    PastDueOver30Days = 9,
    PastDueOver45Days = 10,
    PastDueOver60Days = 11,
    PastDueOver75Days = 12,
    PastDueOver120Days = 13,
    PaymentPlanNotMet = 14,
    PendingDecisionNewAccount = 15,
    PendingDecisionOwnershipChange = 16,
    AccountForInternalUseOnly = 17,
    ActiveRepaymentPlan = 18
}

export const CreditHoldReasonMetadata = {
    '0': {
        display: 'Account On Watch',
        value: 0
    },
    '1': {
        display: 'Certified Funds',
        value: 1
    },
    '2': {
        display: 'CIA',
        value: 2
    },
    '3': {
        display: 'Collections',
        value: 3
    },
    '4': {
        display: 'Demand Letter',
        value: 4
    },
    '5': {
        display: 'Holding Check',
        value: 5
    },
    '6': {
        display: 'NSF Check',
        value: 6
    },
    '7': {
        display: 'Over Credit Limit',
        value: 7
    },
    '8': {
        display: 'Over Credit Limit & Past Due',
        value: 8
    },
    '9': {
        display: 'Past Due - Over 30 Days From Invoice',
        value: 9
    },
    '10': {
        display: 'Past Due - Over 45 Days From Invoice',
        value: 10
    },
    '11': {
        display: 'Past Due - Over 60 Days From Invoice',
        value: 11
    },
    '12': {
        display: 'Past Due - Over 75 Days From Invoice',
        value: 12
    },
    '13': {
        display: 'Past Due - Over 120 Days From Invoice',
        value: 13
    },
    '14': {
        display: 'Payment Plan Not Met',
        value: 14
    },
    '15': {
        display: 'Pending Decision - New Account',
        value: 15
    },
    '16': {
        display: 'Pending Decision - Ownership Change',
        value: 16
    },
    '17': {
        display: 'Account For Internal Use Only',
        value: 17
    },
    '18': {
        display: 'Active Repayment Plan',
        value: 18
    }
};
